import { Id, BoundingBox } from '../types'

export enum ColorMode {
  Dark = 'dark',
  Light = 'light',
}

export enum HaloSize {
  Small = 'small',
  Medium = 'medium',
  Large = 'large',
}

export interface MapsConfig {
  settings: {
    width: number
  }
  maps: {
    zone: Map
    main: Map
    [key: string]: Map
  }
}

export interface Map {
  id: Id
  name: string
  map: string
  boundingBox: BoundingBox
  remainingPOI?: string[]
  // end?: boolean
  width?: number
  order?: number
  color?: ColorMode
  haloSize?: HaloSize
}
